module.exports = __webpack_public_path__ + "media/images/emblems/Coat_Diepoldsau-2f4f795e70cc3a228a7f491b6e263de1.gif";